import { render, staticRenderFns } from "./AssistantService.vue?vue&type=template&id=0a4df4a0"
import script from "./AssistantService.vue?vue&type=script&lang=js"
export * from "./AssistantService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports